import { apiClient } from './client'
import type { TokenResponse, UserResponse, ProfileResponse, ProfileUpdate, ChangePasswordPayload } from '../types'

export async function register(email: string, password: string): Promise<TokenResponse> {
  const { data } = await apiClient.post<TokenResponse>('/api/v1/auth/register', { email, password })
  return data
}

export async function login(email: string, password: string): Promise<TokenResponse> {
  const { data } = await apiClient.post<TokenResponse>('/api/v1/auth/login', { email, password })
  return data
}

export async function refreshToken(): Promise<TokenResponse> {
  const { data } = await apiClient.post<TokenResponse>('/api/v1/auth/refresh')
  return data
}

export async function logout(): Promise<void> {
  await apiClient.post('/api/v1/auth/logout')
}

export async function loginGoogle(code: string): Promise<TokenResponse> {
  const { data } = await apiClient.post<TokenResponse>('/api/v1/auth/oauth/google', { code })
  return data
}

export async function getMe(): Promise<UserResponse> {
  const { data } = await apiClient.get<UserResponse>('/api/v1/auth/me')
  return data
}

export async function getProfile(): Promise<ProfileResponse> {
  const { data } = await apiClient.get<ProfileResponse>('/api/v1/auth/profile')
  return data
}

export async function updateProfile(payload: ProfileUpdate): Promise<ProfileResponse> {
  const { data } = await apiClient.put<ProfileResponse>('/api/v1/auth/profile', payload)
  return data
}

export async function changePassword(payload: ChangePasswordPayload): Promise<void> {
  await apiClient.put('/api/v1/auth/profile/password', payload)
}

export async function verifyEmail(token: string): Promise<void> {
  await apiClient.get('/api/v1/auth/verify-email', { params: { token } })
}
